/** @format */

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Col, Row } from 'antd';
import backArrow from 'img/ArrowLeft.svg';
import { setSelectedFormId } from 'state/slice/buttonSlice';
import { useCustomer } from '../hooks/useCustomer';
import PersonalInfoCard from '../components/PersonalInfoCard';
import AddressInfoCard from '../components/AddressInfoCard';
import BackOfficeInfoCard from '../components/BackOfficeInfoCard';
import FamilyInfoCards from '../components/FamilyInfoCards';
import CustomerPlans from '../components/CustomerPlans';

const CustomerProfile: React.FC = () => {
  const dispatch = useDispatch();
  const selectedFormId = useSelector((state: any) => state.button.selectedFormId);
  
  const { customer, loading, updateCustomer, setCustomer, refetch } = useCustomer(selectedFormId);
  
  const [isEditingPersonalInfo, setIsEditingPersonalInfo] = React.useState(false);
  const [isEditingAddress, setIsEditingAddress] = React.useState(false);

  const handleBack = () => {
    dispatch(setSelectedFormId(null));
  };

  const handleInputChange = (field: string, value: any) => {
    if (!customer) return;
    setCustomer({ ...customer, [field]: value });
  };

  const handleAddressChange = (addressField: string, value: any) => {
    if (!customer) return;
    setCustomer({
      ...customer,
      address: {
        ...customer.address,
        [addressField]: value,
      },
    });
  };

  const handleCancelPersonalInfo = () => {
    setIsEditingPersonalInfo(false);
    if (refetch) {
      refetch();
    }
  };

  const handleCancelAddress = () => {
    setIsEditingAddress(false);
    if (refetch) {
      refetch();
    }
  };

  const saveCustomerDetails = async () => {
    if (!customer) return;
    try {
      await updateCustomer(customer);
      setIsEditingPersonalInfo(false);
      setIsEditingAddress(false);
    } catch (error) {
      console.error('Error updating customer details:', error);
    }
  };

  const toggleEditPersonalInfo = () => {
    if (isEditingPersonalInfo) {
      saveCustomerDetails();
    } else {
      setIsEditingPersonalInfo(true);
    }
  };

  const toggleEditAddress = () => {
    if (isEditingAddress) {
      saveCustomerDetails();
    } else {
      setIsEditingAddress(true);
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!customer) {
    return <div>No form selected.</div>;
  }

  return (
    <div className="customer-details-container" style={{ padding: '20px' }}>
      <button
        className="white-back-button"
        style={{ marginBottom: '20px' }}
        onClick={handleBack}
      >
        <img src={backArrow} alt="Back Arrow" />
        <span>Back</span>
      </button>

      <Row gutter={[16, 16]}>
        <Col span={8}>
          <PersonalInfoCard
            customer={customer}
            isEditing={isEditingPersonalInfo}
            onToggleEdit={toggleEditPersonalInfo}
            onCancelEdit={handleCancelPersonalInfo}
            onInputChange={handleInputChange}
          />
        </Col>

        <Col span={8}>
          <AddressInfoCard
            customer={customer}
            isEditing={isEditingAddress}
            onToggleEdit={toggleEditAddress}
            onCancelEdit={handleCancelAddress}
            onAddressChange={handleAddressChange}
          />
        </Col>

        <Col span={8}>
          <BackOfficeInfoCard customer={customer} />
        </Col>
      </Row>

      <FamilyInfoCards customer={customer} />

      <CustomerPlans customer={customer} onUpdate={updateCustomer} />

      <Row gutter={[16, 16]} style={{ marginTop: '20px' }}>
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className="form-heading">
            <span>Comments</span>
          </div>
        </Col>
        <Col sm={24} md={24} lg={24} xl={24}>
          <div className="form-input-wrapper">
            <span>{customer.notes}</span>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default CustomerProfile;
